import { DOCUMENT, DatePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { CommonService } from "src/app/services/common.service";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";
import { StorageService } from "../../../services/storage.service";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
@Component({
  selector: "app-student-expired",
  templateUrl: "./student-expired.component.html",
  styleUrls: ["./student-expired.component.css"],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class StudentExpiredComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  expandedElement = false;
  page: number = 1;
  page_size: number = 10;
  studentList: any[];
  total_count: any;
  total: any;
  p: number;
  pagedItems: any[];
  department: Object;
  dept: any;
  course: Object;
  courseData: any;
  batch: any;
  batchData: any;
  getstudent: Object;
  pageshow: boolean;
  page_count: any[];
  htmlpageshow = false;
  first_name: any;
  last_name: any;
  mobile_number: any;
  email_address: any;
  username: any;
  department_id: any;
  batch_id: any;
  course_id: any;
  searchForm: any;
  filtervalues: boolean;
  chiparray = [];
  hod: any;
  currentRowId: number;
  StudentForm: FormGroup;
  start_date: string;
  submitted = false;
  stuupdate: any;
  expiry_date: any;
  student: any;
  id: any;
  user_id: any;
  maxDate = new Date();
  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public router: Router,
    private route: ActivatedRoute,
    private datepipe: DatePipe,
    private fb: FormBuilder,
    public globalService: GlobalService,
    public fileupload: CommonService,
    private spinner: NgxSpinnerService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  async ngOnInit(): Promise<void> {
    this.hod = this.storageService.getHod();
    this.searchForm = this.fb.group({
      id: [""],
      fname: [""],
      lname: [""],
      uname: [""],
      email: [""],
      mobile: [""],
      depname: [null],
      courname: [""],
      batchname: [""],
    });
    this.StudentForm = this.fb.group({
      filter_date_start: [""],
      id: [""],
    });

    if (this.storageService.getRole() === 4 && this.hod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].disable();
    }
    await this.getPage(this.page);
    await this.getDepartment();
    await this.getBatch();
    await this.getCourse();
    
  }
  get forms1() {
    return this.searchForm.controls;
  }
  async getPage(page: number) {
    this.page = page;
    await this.getStudent();
    const res = await this.serverCall(this.studentList, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }

  onUpdate(content, currentRowId) {
    this.document.body.classList.add('date-cls');
    if (this.ls.get("token")) {
      this.currentRowId = currentRowId;
      const modalRef = this.modalService.open(content, { scrollable: true });
      modalRef.result.then((data) => {
        this.document.body.classList.remove('date-cls');
      }, (reason) => {
        this.document.body.classList.remove('date-cls');
      });
    }
  }

  onClose() {
    this.document.body.classList.remove('date-cls');
  }

  async updateStudentExpiryList(form: FormGroup) {
    this.spinner.show();

    const inputData = {
      id: this.currentRowId,
      vendor_id: this.ls.get("vendor_id"),
      user_id: this.ls.get("createdBy"),
      role_id: "5",
      expiry_date: this.start_date
        ? this.start_date
        : form.value.filter_date_start,
    };

    this.stuupdate = await this.globalService.update(
      "commonUser/expiry-update",
      inputData
    );
    this.spinner.hide();
    if (this.stuupdate["status"] === 200) {
      this.pageshow = true;
      this.getStudent();
      this.modalService.dismissAll();
    }
  }

  async getDepartment() {
    this.spinner.show();
    let filter = {
      id: this.id,
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: "5",
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,true
    );

    this.dept = this.department["content"];
    this.spinner.hide();
  }
  async getCourse() {
    this.spinner.show();
    let filter = {
      id: this.id,
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: "5",
    };
    this.course = await this.globalService.get("course/list/dropdown", filter,true);

    this.courseData = this.course["content"];
    this.spinner.hide();
  }
  async getBatch() {
    this.spinner.show();
    let filter = {
      id: this.id,
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: "5",
    };
    this.batch = await this.globalService.get("batch/list/dropdown", filter,true);

    this.batchData = this.batch["content"];
    this.spinner.hide();
  }

  async getStudent() {
    this.spinner.show();
    if (this.page === 1) {
      this.studentList = [];
    }

    let filter = {
      id: this.id,
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      page_size: this.page_size,
      role_id: "5",
      first_name: this.first_name,
      last_name: this.last_name,
      email_address: this.email_address,
      mobile_number: this.mobile_number,
      username: this.username,
      department_id: this.department_id,
      batch_id: this.batch_id,
      course_id: this.course_id,
    };

    this.getstudent = await this.globalService.get(
      "commonUser/list-expired-student",
      filter
    )
    if (this.getstudent["status"] === 200) {
      this.total_count = this.getstudent["content"].count;
      this.studentList = this.getstudent["content"]["rows"];
      this.studentList = this.studentList.map((list) => {
        list["isExpand"] = false;
        return list;
      });
      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.total_count / this.page_size);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
    } else {
      this.spinner.hide();
    }

    (error) => {
      this.studentList = [];
      this.spinner.hide();
    };

    this.spinner.hide();
  }
  expandRow(eList) {
    this.studentList.forEach((list) => {
      if (eList.id === list.id) {
        list["isExpand"] = true;
      } else {
        list["isExpand"] = false;
      }
    });
  }
  collapseRow(eList) {
    this.studentList.forEach((list) => {
      list["isExpand"] = false;
    });
  }
  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
    if (this.storageService.getRole() === 4 && this.hod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].disable();
    }
  }
  Filter(
    first_name,
    last_name,
    email_address,
    mobile_number,
    username,
    department_id,
    batch_id,
    course_id
  ) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.first_name != undefined && this.first_name != "") {
      this.chiparray.push("Fname :" + " " + this.first_name);
    }

    if (this.last_name != undefined && this.last_name != "") {
      this.chiparray.push("Lname :" + " " + this.last_name);
    }
    if (this.username != undefined && this.username != "") {
      this.chiparray.push("Uname :" + " " + this.username);
    }
    if (this.email_address != undefined && this.email_address != "") {
      this.chiparray.push("Email :" + " " + this.email_address);
    }
    if (this.mobile_number != undefined && this.mobile_number != "") {
      this.chiparray.push("Mobile :" + " " + this.mobile_number);
    }

    if (this.course_id != undefined && this.course_id != "") {
      var course = this.courseData.filter((x) => x.id == this.course_id);
      this.chiparray.push("Course:" + " " + course[0].name);
    }

    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }

    if (this.batch_id != undefined && this.batch_id != "") {
      var batch = this.batchData.filter((x) => x.id == this.batch_id);
      this.chiparray.push("Batch:" + " " + batch[0].batch);
    }

    this.first_name = first_name;
    this.last_name = last_name;
    this.email_address = email_address;
    this.mobile_number = mobile_number;
    this.username = username;
    this.department_id = department_id;
    this.batch_id = batch_id;
    this.course_id = course_id;
    this.pageshow = true;
    this.page = 1;
    this.getStudent();
  }
  setFilterStartDate(filter_date) {
    if (!filter_date) {
      return false;
    }
  }

  res() {
    this.filtervalues = false;
    if (this.storageService.getRole() != 4 && this.hod != 1) {
      this.department_id = null;
    }
    this.filtervalues = false;
    this.first_name = null;
    this.last_name = null;
    this.email_address = null;
    this.mobile_number = null;
    this.username = null;
    this.batch_id = null;
    this.course_id = null;
    this.searchForm.reset();
    this.StudentForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getStudent();
  }

  paginationCount(value) {
    this.page = 1;
    if(value>=5){
    this.page_size = value;
    }
    this.getStudent();
  }
}
